import React from "react";

const LinkExpiredPage: React.FC = () => {
  const handleClose = () => {
    window.close();
    // Show fallback message because some browsers will block the close
    alert(
      "If the page didn't close automatically, please close this tab manually."
    );
  };

  return (
    <div className='min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-purple-50 to-white px-4'>
      <div className='bg-white shadow-lg rounded-xl p-8 max-w-md w-full text-center'>
        {/* Icon Container */}
        <div className='mx-auto mb-4 w-20 h-20 flex items-center justify-center rounded-full bg-[#F3943F]/10'>
          <svg
            className='w-10 h-10 text-[#F3943F]' // 40px (10 * 4 = 40px)
            fill='none'
            stroke='currentColor'
            strokeWidth={2}
            viewBox='0 0 24 24'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
            />
          </svg>
        </div>

        {/* Title */}
        <h2 className='text-2xl font-semibold mb-2 text-gray-800'>
          Link Expired or Not Valid
        </h2>

        {/* Message */}
        <p className='text-gray-600 mb-6'>
          The link you tried to access is either invalid or has expired. Please
          close this page and try again with a valid link.
        </p>

        {/* Close Button */}
        <button
          onClick={handleClose}
          className='w-full bg-gradient-to-r from-[#F3943F] to-[#e6842e] text-white py-2 rounded-lg hover:opacity-90 transition'>
          Close This Page
        </button>
      </div>
    </div>
  );
};

export default LinkExpiredPage;
